import React, { useState, useEffect } from "react"
import styled from "styled-components"
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextareaAutosize,
  IconButton,
  TextField,
  FormHelperText,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup
} from "@material-ui/core"
import AttachFileIcon from "@material-ui/icons/AttachFile"
import DeleteIcon from "@material-ui/icons/Delete"

const StyButton = styled(Button)`
  min-width: 80px;
  height: 40px;
  font-size: 13px;
  font-weight: 700;

  &.disable {
    background-color: #d1d1d1;
    color: white;
  }

  &.submit {
    background-color: var(--primaryColor);
    color: white;
  }

  &.cancel {
    borderColor: var(--primaryColor);
    color: var(--primaryColor);
  }


  @media(max-width:425px) {
    padding: 5px;
    & .MuiSvgIcon-root {
      fontSize: 15px;
    }
    & .MuiButton-label {
      fontSize: 10px;
    }
  }


`

const MonitorComments = (props) => {
  const {
    open = false,
    handleCommentsClose = () => { },
    getCommentsReason = "",
    onSubmit = () => { },
    currentTab = "",
    placeholder = "Type here"
  } = props

  // states
  const [getOpen, setOpen] = useState(false);
  const [commentsReason, setCommentsReason] = useState('');
  const [required, setRequired] = useState(false);
  const [requiredError, setRequiredError] = useState(false);
  const [submitDisable, setSubmitDisable] = useState(true);
  const [actionType, setActionType] = useState("");
  const [showLabel, setShowLabel] = useState(true);
  const [getPlaceholder, setPlaceholder] = useState('');

  // effects
  useEffect(() => {
    setCommentsReason(getCommentsReason)
    decidePlaceholder({ required, showLabel, placeholder })

  }, [])

  useEffect(() => {
    setOpen(open)
    if (props.currentTab === "Acknowledged") {
      setActionType("2")
      setShowLabel(false)
      setSubmitDisable(false)
    }
  }, [open])

  useEffect(() => {
    decidePlaceholder({ required, showLabel, placeholder })
  }, [required, showLabel, placeholder])

  useEffect(() => {
    if (actionType === "2" && props.currentTab === "New") {
      setRequired(true)
      commentsReason.length > 0 ? setSubmitDisable(false) : setSubmitDisable(true)
    } else {
      setRequired(false)
      setRequiredError(false)
    }
  }, [actionType])

  // functionalities
  const handleClose = () => {
    handleCommentsClose(false)
    setOpen(true)
    setCommentsReason("")
    setActionType("")
    setSubmitDisable(true)
  }

  const decidePlaceholder = ({ required, showLabel, placeholder }) => {
    if (showLabel) {
      if (required) {
        setPlaceholder(`${placeholder}`)
      } else {
        setPlaceholder(`${placeholder} (Optional)`)
      }
    } else {
      if (required) {
        setPlaceholder(`Comments`)
      } else {
        setPlaceholder(`Comments (Optional)`)
      }
    }
  }


  return (
    <Dialog
      open={getOpen}
      onClose={handleClose}
      aria-labelledby="draggable-dialog-title"
      style={{ width: "350px", marginLeft: "auto", marginRight: "auto" }}
    >

      {(props.currentTab === "Acknowledged") ? (
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          <h3>Resolve</h3>
        </div>
      ) : (
        <div style={{ padding: "20px", paddingTop: "5px" }}>
          <h3>Select Action</h3>
          <FormGroup>
            <RadioGroup
              value={actionType}
              onChange={(e) => {
                setActionType(e.target.value)
                setSubmitDisable(false)
              }}
            >
              <FormControlLabel
                size="small"
                control={<Radio />}
                value="1"
                label="Acknowledge"
                disabled={props.currentTab === "Acknowledged" && true}
              />
              <FormControlLabel
                size="small"
                control={<Radio />}
                value="2"
                label="Resolved"
              />
            </RadioGroup>
          </FormGroup>
        </div>
      )}

      <Divider
        orientation="horizontal"
        flexItem
      />
      <Grid
        container
        direction="row"
        style={{ padding: "0px 15px 10px 15px" }}
      >
        <Grid item container xs={12}
          style={{
            marginBottom: '10px'
          }}
        >

          {(showLabel) && (
            <>
              <Typography
                variant="h5"
                style={{
                  marginBottom: "14px",
                  marginLeft: "4px",
                  fontWeight: "600",
                }}

              >
                Comments
                {required && (<>
                  <span style={{ color: "red" }}>
                    {"*"}
                  </span>
                </>)}
              </Typography>
            </>
          )}

          <TextField
            type="text"
            variant="outlined"
            name="TaxFailureReason"
            placeholder={getPlaceholder}
            multiline
            rows={6}
            value={commentsReason}
            helperText={
              requiredError ? 'This field is required' :
                (commentsReason.length < 255)
                  ? `${commentsReason.length}/255`
                  : `Maximum 255 character only`
            }
            error={requiredError ? requiredError : commentsReason.length >= 255}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 255) {
                setCommentsReason(value);
              }
              if (value.length > 0 && requiredError) {
                setRequiredError(false)
              }
              setSubmitDisable(false)
            }}
            required={required}
            style={{
              width: "350px",
              height: "150px",
              fontFamily: `unset`,
              backgroundcolor: "#edf3f3",
              borderRadius: "10px",
            }}
          />
        </Grid>
        <div
          style={{
            padding: 5,
          }}
        >
          <StyButton
            className="cancel"
            variant="outlined"
            color="default"
            onClick={handleClose}
          >
            Cancel
          </StyButton>
        </div>
        <div
          style={{
            padding: 5,
          }}
        >
          <StyButton
            className={`${actionType !== "" ? submitDisable ? 'disable' : 'submit' : 'disable'}`}
            variant="contained"
            color="default"
            disabled={actionType === "" ? true : submitDisable}
            onClick={() => {
              if (required) {
                if (commentsReason.length > 0) {
                  onSubmit({ actionType, commentsReason })
                  setCommentsReason("")
                  setActionType("")
                }
                setRequiredError(commentsReason.length === 0)
              } else {
                onSubmit({ actionType, commentsReason })
              }
              setSubmitDisable(true)
            }}
          >
            Submit
          </StyButton>
        </div>
      </Grid>
    </Dialog>
  )
}

export { MonitorComments }
export default MonitorComments
